/** Gates the manual "Open Flow B" override button (dev/local testing only) — not the real sticky A/B cookie split, which is live in prod. */
export function canAccessFlowVersionB() {
  const env = (process.env.REACT_APP_ENV || "").toLowerCase();
  return env === "local" || env === "dev";
}
